import * as P from '@radix-ui/react-popover';
import type { ReactNode } from 'react';

/**
 * Kleines Auswahlfenster an einem Element (Termin, Zuständige). Gesteuert über `open`, damit es auch per Tastenkürzel
 * oder Menü geöffnet werden kann; `anchor` ist das Element, an dem es erscheint.
 */
export function Popover({ open, onOpenChange, anchor, label, children }: { open: boolean; onOpenChange: (o: boolean) => void; anchor: ReactNode; label: string; children: ReactNode }) {
  return (
    <P.Root open={open} onOpenChange={onOpenChange}>
      <P.Anchor asChild>{anchor}</P.Anchor>
      <P.Portal>
        <P.Content
          aria-label={label}
          align="end"
          sideOffset={4}
          collisionPadding={8}
          onPointerDown={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          className="menu-pop z-50 w-72 max-w-[calc(100vw-16px)] rounded-xl border border-zinc-200 bg-white p-2 text-sm shadow-lg dark:border-zinc-800 dark:bg-zinc-900"
        >
          {children}
        </P.Content>
      </P.Portal>
    </P.Root>
  );
}
